import React, { useEffect } from "react";
import styled from "styled-components";
import { Input, Table, Tag, Tooltip as AntdTooltip } from "antd";
import { useTranslation } from "react-i18next";

const PurchaseSuggestionsTable = ({ restockSuggestions }) => {
  const { t } = useTranslation();
  const [filteredProducts, setFilteredProducts] = React.useState(restockSuggestions);

  useEffect(() => {
    setFilteredProducts(restockSuggestions);
  }, [restockSuggestions]);

  const handleSearch = (value) => {
    if (value === "") setFilteredProducts(restockSuggestions);
    const filtered = restockSuggestions.filter(
      (product) =>
        product.name.toLowerCase().includes(value.toLowerCase()) ||
        product.code?.toLowerCase().includes(value.toLowerCase()),
    );
    setFilteredProducts(filtered);
  };

  return (
    <Card>
      <CardTitle>{t("purchase_suggestions")}</CardTitle>
      <Input
        placeholder={t("search")}
        onChange={(e) => handleSearch(e.target.value)}
        style={{ marginBottom: 6, width: "fit-content" }}
      />
      <Table
        dataSource={filteredProducts}
        columns={[
          {
            title: t("name"),
            dataIndex: "name",
          },
          {
            title: t("average_sales_per_day"),
            dataIndex: "avgDailySales",
            render: (text, record) => (
              <span>
                {text.toFixed(1).replace(".", ",")} {t("pieces").toLowerCase()}
              </span>
            ),
          },
          {
            title: t("predicted_sales_30_days"),
            dataIndex: "predictedSales",
            key: "predictedSales",
            render: (text, record) => {
              // Bepaal marge op basis van betrouwbaarheid
              let margin;
              let tooltipText;

              switch (record.confidence) {
                case "hoog":
                  margin = 0.05; // 5% marge
                  tooltipText = t("high_confidence");
                  break;
                case "gemiddeld":
                  margin = 0.15; // 15% marge
                  tooltipText = t("medium_confidence");
                  break;
                case "laag":
                  margin = 0.25; // 25% marge
                  tooltipText = t("low_confidence");
                  break;
                default:
                  margin = 0.15;
                  tooltipText = t("medium_confidence");
              }

              // Bereken minimum en maximum van het bereik
              const minSuggestedRestock = Math.ceil(text * (1 - margin));
              const maxSuggestedRestock = Math.ceil(text * (1 + margin));

              // Formateer het bereik voor weergave
              const suggestedRestockRange = `${minSuggestedRestock} - ${maxSuggestedRestock}`;

              // Bepaal tekstkleur op basis van betrouwbaarheid
              const badgeTextColor =
                {
                  hoog: "green", // donkergroen
                  gemiddeld: "orange", // oranje-bruin
                  laag: "red", // donkerrood
                }[record.confidence] || "#374151";

              return (
                <AntdTooltip title={tooltipText}>
                  <Tag color={badgeTextColor}>
                    {suggestedRestockRange} {t("pieces").toLowerCase()}
                  </Tag>
                </AntdTooltip>
              );
            },
          },
        ]}
      />
    </Card>
  );
};

const Card = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);
  padding: 1rem;
  margin-bottom: 1.5rem;
`;

const CardTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

export default PurchaseSuggestionsTable;
